import React from 'react';
import { connect } from 'react-redux';
import { Popover } from 'react-bootstrap';

class SidebarAwarePopover extends React.Component {
  render() {
    const {
      breakpointIndex,
      placement,
      positionTop,
      positionLeft,
      arrowOffsetTop,
      arrowOffsetLeft,
      children,
      className,
    } = this.props;

    let newPositionLeft = positionLeft;
    if (breakpointIndex > 1 && positionLeft < 70) {
      newPositionLeft = 70;
    }

    return (
      <Popover
        placement={placement}
        positionTop={positionTop}
        positionLeft={newPositionLeft}
        arrowOffsetTop={arrowOffsetTop}
        arrowOffsetLeft={arrowOffsetLeft}
        className={className}
        id={`popover-positioned-${placement}`}
      >
        {children}
      </Popover>
    );
  }
}
SidebarAwarePopover.defaultProps = {
  className: '',
};

const mapStateToProps = state => {
  return {
    breakpointIndex: state.layout.breakpointIndex,
  };
};

export default connect(mapStateToProps)(SidebarAwarePopover);
